import { ChangeDetectionStrategy, Component, inject, input } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { SadmEntityDisplay } from '@modules/sadm/models/sadm-entity-display';
import { SadmGridService } from '@modules/sadm/services/sadm-grid.service';
import { TuiButton, TuiHint } from '@taiga-ui/core';

@Component({
  selector: 'pxc-sadm-document-shortcut',
  templateUrl: './sadm-document-shortcut.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'pointer-events-none absolute right-2 top-2 z-10 opacity-0 transition-opacity duration-100 focus-within:pointer-events-auto focus-within:opacity-100 group-hover:pointer-events-auto group-hover:opacity-100',
  },
  imports: [TranslocoDirective, TuiButton, TuiHint],
})
export class SadmDocumentShortcutComponent {
  readonly sadmEntity = input.required<SadmEntityDisplay>();

  private readonly sadmGridService = inject(SadmGridService);

  openGrid(): void {
    const { sadmClient, patient } = this.sadmEntity();
    this.sadmGridService.openGrid(sadmClient, patient).subscribe();
  }
}
